import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import { Router, Link } from "@reach/router";
import Divider from "@material-ui/core/Divider";
import { withSnackbar } from "notistack";
import SERVER_ADDRESS from "../../../config";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import SvgIcon from "@material-ui/core/SvgIcon";
import Typography from "@material-ui/core/Typography";

import { testNames, fullGrade, testNameList, simpleFullGrade } from "./config";

const useStyles = makeStyles(theme => ({
  table: {
    width: "100%"
  },
  tableHead: {
    backgroundColor: theme.palette.secondary.light
  },
  tableCell: {
    color: theme.palette.common.white
  }
}));

function filterGoujianTest(grades, filterTestName) {
  return grades.filter(grade => grade.test_type === filterTestName);
}

function classifyGoujianTestGrade(grades) {
  const goujianGrades = filterGoujianTest(grades, testNames.a);
  //   {goujianName: '2015.01', right: 4000, totle: 2400}
  const classifiedData = {};
  goujianGrades.forEach(({ specification }) => {
    specification.forEach(({ rightAnswer, studentAnswer }) => {
      const gradeAdd = studentAnswer === rightAnswer ? 1 : 0;
      if (Object.keys(classifiedData).indexOf(rightAnswer) !== -1) {
        classifiedData[rightAnswer].total += 1;
        classifiedData[rightAnswer].right += gradeAdd;
      } else {
        classifiedData[rightAnswer] = { right: gradeAdd, total: 1 };
      }
    });
  });
  return Object.keys(classifiedData).map(goujianName => {
    return {
      goujianName,
      right: classifiedData[goujianName].right,
      total: classifiedData[goujianName].total,
      wrong:
        classifiedData[goujianName].total - classifiedData[goujianName].right,
      percent: Number(
        ((classifiedData[goujianName].total -
          classifiedData[goujianName].right) /
          classifiedData[goujianName].total) *
          100
      ).toFixed(0)
    };
  });
}

function GoujianTestTable(props) {
  const classes = useStyles();
  const { gradeData } = props;
  const data = classifyGoujianTestGrade(gradeData);
  //data按照错误率排序
  data.sort((firstEl, secondEl) => {
    return secondEl.percent - firstEl.percent;
  });
  const tableHeadTitle = [
    { columnField: "goujianName", columnName: "构件名称" },
    { columnField: "right", columnName: "正确次数" },
    { columnField: "wrong", columnName: "错误次数" },
    { columnField: "total", columnName: "测试总次数" },
    { columnField: "percent", columnName: "错误率" }
  ];
  return (
    <>
      {data.length > 0 ? (
        <Table className={classes.table}>
          <TableHead className={classes.tableHead}>
            <TableRow>
              {tableHeadTitle.map(({ columnField, columnName }) => (
                <TableCell align="left" key={columnField}>
                  <Typography
                    variant="subtitle1"
                    color="textPrimary"
                    className={classes.typography}
                  >
                    {columnName}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map(({ goujianName, right, wrong, total, percent }) => {
              return (
                <TableRow key={goujianName} hover>
                  <TableCell component="th" scope="row">
                    {goujianName}
                  </TableCell>

                  <TableCell align="left">{right}</TableCell>
                  <TableCell align="left">{wrong}</TableCell>
                  <TableCell align="left">{total}</TableCell>
                  <TableCell align="left">{`${percent}%`}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <Typography
          variant="h6"
          color="textPrimary"
          className={classes.typography}
        >
          "还未进行构件辨识实验"
        </Typography>
      )}
    </>
  );
}

export default GoujianTestTable;
